import { useLocation } from 'react-router-dom'


export default function DesignSidebar() {
    const location = useLocation();
    switch (location.pathname) {
        case "/design":
            return (
                <div class="mx-5 my-8 w-full">
                    <a href="/design#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r from-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">DRIVETRAIN</p>
                        </button>
                    </a>
                    <a href="/design/intake#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-size-200 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r from-frcblue via-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">INTAKE</p>
                        </button>
                    </a>
                    <a href="/design/rotary#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-size-200 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r from-frcblue via-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">ROTARY</p>
                        </button>
                    </a>
                    <a href="/design/belt#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-size-200 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r from-frcblue via-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">BELT</p>
                        </button>
                    </a>
                </div>
            )
        case "/design/intake":
            return (
                <div class="mx-5 my-8 w-full">
                    <a href="/design#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r bg-size-200 from-frcblue via-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">DRIVETRAIN</p>
                        </button>
                    </a>
                    <a href="/design/intake#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r from-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">INTAKE</p>
                        </button>
                    </a>
                    <a href="/design/rotary#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r bg-size-200 from-frcblue via-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">ROTARY</p>
                        </button>
                    </a>
                    <a href="/design/belt#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r bg-size-200 from-frcblue via-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">BELT</p>
                        </button>
                    </a>
                </div>
            )
        case "/design/rotary":
            return (
                <div class="mx-5 my-8 w-full">
                    <a href="/design#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r bg-size-200 from-frcblue via-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">DRIVETRAIN</p>
                        </button>
                    </a>
                    <a href="/design/intake#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r bg-size-200 from-frcblue via-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">INTAKE</p>
                        </button>
                    </a>
                    <a href="/design/rotary#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r from-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">ROTARY</p>
                        </button>
                    </a>
                    <a href="/design/belt#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r bg-size-200 from-frcblue via-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">BELT</p>
                        </button>
                    </a>
                </div>
            )
        case "/design/belt":
            return (
                <div class="mx-5 my-8 w-full">
                    <a href="/design#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r bg-size-200 from-frcblue via-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">DRIVETRAIN</p>
                        </button>
                    </a>
                    <a href="/design/intake#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r bg-size-200 from-frcblue via-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">INTAKE</p>
                        </button>
                    </a>
                    <a href="/design/rotary#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r bg-size-200 from-frcblue via-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">ROTARY</p>
                        </button>
                    </a>
                    <a href="/design/belt#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r from-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">BELT</p>
                        </button>
                    </a>
                </div>
            )
        case "/design/5mmbelt":
            return (
                <div class="mx-5 my-8 w-full">
                    <a href="/design#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r bg-size-200 from-frcblue via-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">DRIVETRAIN</p>
                        </button>
                    </a>
                    <a href="/design/intake#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r bg-size-200 from-frcblue via-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">INTAKE</p>
                        </button>
                    </a>
                    <a href="/design/rotary#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r bg-size-200 from-frcblue via-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">ROTARY</p>
                        </button>
                    </a>
                    <a href="/design/belt#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r bg-size-200 from-frcblue via-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">BELT</p>
                        </button>
                    </a>
                </div>
            )
        default:
            return (
                <div class="mx-5 my-8 w-full">
                    <a href="/design#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r bg-size-200 from-frcblue via-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">DRIVETRAIN</p>
                        </button>
                    </a>
                    <a href="/design/intake#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r bg-size-200 from-frcblue via-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">INTAKE</p>
                        </button>
                    </a>
                    <a href="/design/rotary#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r bg-size-200 from-frcblue via-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">ROTARY</p>
                        </button>
                    </a>
                    <a href="/design/belt#tool">
                        <button type="button" class="transition-all w-full h-32 ease-in-out delay-150 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r bg-size-200 from-frcblue via-frcpurple to-frcyellow px-5 py-2.5 text-center mr-2 mb-2 rounded-lg">
                            <p class="text-white bg-clip-text font-scoutcond font-black text-5xl">BELT</p>
                        </button>
                    </a>
                </div>
            )
    }

}